import React, { useEffect, useRef, useState } from 'react';
import { actions } from 'react-redux-form';

import store from '../../../store';

const CustomSearchableSelect = (props) => {
    const { label, options=[], optionLabelKey, selected, placeholder, requiredField, isError, name, disabled = false, displayOption, maxLength, isMainFilter } = props;
    const [inputValue, setInputValue] = useState('');
    const [showOptions, setShowOptions] = useState(false);
    const [modifiedOptions, setModifiedOptions] = useState([]);
    const wrapperRef = useRef(null);
    const inputValueRef = useRef('');



    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShowOptions(false);

            if (
                inputValueRef.current &&
                inputValueRef.current.value === "" &&
                requiredField &&
                selected !== undefined &&
                selected !== null
            ) {
                setInputValue(selectedValue(selected));
                setModifiedOptions(transformOptions(options));
                return;
            }

            // display selected value when choosen no value
            if (inputValueRef.current && inputValueRef.current.value === "") {
                setInputValue(selectedValue(undefined)); // clear input value
                setModifiedOptions(transformOptions(options)); // reset options
                if (isMainFilter === true) {
                    handleOptionClick(options);
                }
             }
             // Check if input value does not exist in options
             else if (inputValueRef.current && modifiedOptions.findIndex(o => o.Value == inputValueRef.current.value) == -1) {
                 if (name == "inventoryEquipmentForm.costCodeId"
                     && (inputValueRef.current.value != null && inputValueRef.current.value != "")
                     && modifiedOptions.findIndex(o => o.Label == inputValueRef.current.value) >= 0) { //special case for Bug 55079 since Cost Center field is using optionLabelKey={OPTION_LABEL.KEY_VALUE_LABEL}
                     setInputValue(selectedValue(selected)); // Set your desired default value here
                 }
                 else {
                     setInputValue(selectedValue(undefined)); // clear input value
                     setModifiedOptions(transformOptions(options)); // reset options
                     if (isMainFilter === true) {
                         handleOptionClick(options);
                     }
                 }
                 
             }
             // Reset input value if no selected
             else if (inputValueRef.current && inputValueRef.current.value !== "" && !selected) {
                 setInputValue(selectedValue(undefined)); // clear input value
                 setModifiedOptions(transformOptions(options)); // reset options
             }
        }
        else {
             // Reset if no selected and no input value
            if (inputValueRef.current && inputValueRef.current.value === "" && !selected) {
                setInputValue(selectedValue(undefined)); // clear input value
                setModifiedOptions(transformOptions(options)); // reset options
            }
 
        }
    };

    const transformOptions = (options=[]) => {
        if (options === null || options === undefined || !Array.isArray(options)) {
            return [];
        }
        const transformed = options?.map(option => {
            return {
                Key: option[optionLabelKey?.Key],
                Value: option[optionLabelKey?.Value],
                Label: option[optionLabelKey?.Label]
            };
        });

        return transformed;
    };


    const handleSearchChange = (e) => {
        if (e === '') {
            // Call the onChange handler with null or an empty value to notify the parent component
            if (typeof props.onChange === 'function') {
                props.onChange(null);
            }

        }
        else {
            const value = e.target.value;
            setInputValue(value);
            // Perform live search
            if (value === "") {
                setModifiedOptions(transformOptions(options));
                if (!requiredField) {
                    store.dispatch(actions.change(name, ""));
                    store.dispatch(actions.change(props.fieldProp, ""));
                }
            }
            else {
                const filteredOptions = options.filter(option =>
                    option.LocationSite && option.LocationSite.toLowerCase().includes(value.toLowerCase()) ||
                    option.Idhr && option.Idhr.toLowerCase().includes(value.toLowerCase()) ||
                    option.BillingAccount && option.BillingAccount.toLowerCase().includes(value.toLowerCase()) ||
                    option.FilterName && option.FilterName.toLowerCase().includes(value.toLowerCase()) ||
                    option.CircuitCode && option.CircuitCode.toLowerCase().includes(value.toLowerCase()) ||
                    option.Value && option.Value.toLowerCase().includes(value.toLowerCase()) ||
                    option.EquipmentModel && option.EquipmentModel.toLowerCase().includes(value.toLowerCase()) ||
                    option.AccountNumber && option.AccountNumber.toLowerCase().includes(value.toLowerCase()) ||
                    option.PlanName && option.PlanName.toLowerCase().includes(value.toLowerCase())
                );
                const limitedOptions = filteredOptions.slice(0, 10);
                setModifiedOptions(transformOptions(limitedOptions));
            }
        }
    };

    const selectedValue = (Key) => {
        if (Key === undefined) {
            return '';
        }

        const transOptions = displayOption ? options : transformOptions(options);
        if (props.name == 'inventoryCircuitEquipForm.ModelId') {
            const result = transOptions?.find(option => option.Key === Key.toString());
            return displayOption ? result?.Label : result?.Value;
        } else {
            const result = transOptions?.find(option => option.Key === Key);
            return displayOption ? result?.Label : result?.Value;
        }
    };

    const handleOptionClick = (option) => {

        const { onChange, tagName } = props;
        setShowOptions(false);

        var valObj = {
            target: {
                tagName: tagName ? tagName : "SEARCHABLE-SELECT",
            },
            value: option.Value,
            text: option.Value,
            key: option.Key,
        };

        if (typeof onChange === 'function') {
            if (tagName === "SEARCHABLE-SELECT") {
                onChange(valObj);
                store.dispatch(actions.change(name, valObj.key));
            }
            else {
                onChange(valObj.key);
                store.dispatch(actions.change(name, valObj.key));
            }
        }
        setInputValue(valObj?.value);

    };

    const handleOnBlur = (event) => {
        const acceptedEvent = event.code == "Tab" || event.type == "blur";
        if (modifiedOptions.findIndex(o => o.Value == inputValue) == -1 && !showOptions && acceptedEvent) {
            store.dispatch(actions.change(name, ""));
            store.dispatch(actions.change(props.fieldProp, ""));
            if (props.onBlurHandler) {
                props.onBlurHandler();
            }
        }
    }

    useEffect(() => {
        if (selected !== null && selected !== undefined) {
            setInputValue(selectedValue(selected))
        }
    }, [selected])

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleOnBlur);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleOnBlur);
        };
    });

    useEffect(() => {
        if (options.length > 0 && props.fieldProp != 'inventoryCicuitPlanDetailsForm.PlanId')
        {
            setModifiedOptions(transformOptions(options));
        }
        else if (options.length >= 0 && props.fieldProp == 'inventoryCicuitPlanDetailsForm.PlanId')
        {
            setModifiedOptions(transformOptions(options));
        }
    }, [options]);

    return (
        <div ref={wrapperRef} className={`custom-select-wrapper ${requiredField ? "required" : ""} ${disabled ? "disabled" : ""} ${isError ? "border-red" : ""} ${showOptions? "border-blue" : ""}`}>
            <div className="custom-select-label">{label}</div>
            <input
                className={`${disabled ? "custom-select-input disabled" : "custom-select-input"} mb-0 form-select`}
                type="text"
                placeholder={placeholder}
                value={inputValue ? inputValue : ""}
                onChange={handleSearchChange}
                onFocus={() => setShowOptions(true)}
                onBlur={handleOnBlur}
                disabled={disabled}
                ref={inputValueRef}
                maxLength={maxLength}
            />
            {showOptions && (
                <ul className="custom-select-options">
                    {modifiedOptions.map((option, index) => (
                        <li
                            key={index}
                            onClick={() => handleOptionClick(option)}
                            className="custom-select-option"
                        >
                            {option.Value}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CustomSearchableSelect;
